export default "__VITE_ASSET__B$$hWfDZ__ 1200w";